<dashboard-dialog-frame [icon]='icon()' [header]='header()' [actions]='actions' [dialogRef]='dialogRef'>

	<h3 style="text-align: center; margin: 2em">Is <b>Rush</b> the best band ever?</h3>

	<div style="text-align:center">

		<hr>

		<iframe width="560" height="315"
			src="https://www.youtube.com/embed/g_QtO0Rhp0w?si=8APZgGGpTv9Jp3ay"
			title="YouTube video player" frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

		<hr>

		<iframe width="560" height="315"
			src="https://www.youtube.com/embed/YSToKcbWz1k?si=JdHpP_DmlS5_5YA_"
			title="YouTube video player" frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

		<hr>

		<iframe width="560" height="315" src="https://www.youtube.com/embed/iq3yjfoorsU?si=GsMejgFp5Et2fTwr"
			title="YouTube video player" frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

		<hr>

		<iframe width="560" height="315" src="https://www.youtube.com/embed/vJOaKdBmk3U?si=nGIwKfJN-rTvnVrb"
			title="YouTube video player" frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

		<hr>

		<iframe width="560" height="315" src="https://www.youtube.com/embed/vDUBK7wXlZM?si=HL5uU4qOiMtxle-N"
			title="YouTube video player" frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>


		<hr>

		<iframe width="560" height="315" src="https://www.youtube.com/embed/-IdkYuxzcD0?si=gwB3hx2E2iFmVfF6"
			title="YouTube video player" frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

	</div>

</dashboard-dialog-frame>